<template>
  <div class="custom-input-color-group">
    <i class="custom-input-color-icon"></i>
    <input
      v-bind="$attrs"
      :value="value"
      v-on="inputListeners"
      class="form-control"
      :data-testid="testid"
    >
  </div>
</template>

<script>
  import EventBus from '../event_bus';

  export default {
    inheritAttrs: false,
    props: ['field_name', 'value', 'testid', 'width'],
    computed: {
      inputListeners: function () {
        let vm = this;
        return Object.assign({},
          this.$listeners,
          {
            input: function (event) {
              EventBus.$emit(`update:${vm.field_name}`, event.target.value);
            },
            focusin: function(event) {
              EventBus.$emit(`toggle:picker:${vm.field_name}`);
            },
            click: function (e) {
              e.stopPropagation();
            }
          }
        )
      }
    }
  }
</script>

<style scoped>
  .custom-input-color-group {
    position: relative;
  }
  .custom-input-color-icon {
    background: url('~images/icons-rainbow-circle.png') right no-repeat;
    position: absolute;
    width: 16px;
    height: 16px;
    right: 8px;
    top: 15px;
  }

</style>